import { defineStore } from 'pinia'
import axios from '@/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token') || null,
    user: null
  }),
  getters: {
    isAuthenticated(state) {
      return !!state.token
    }
  },
  actions: {
    async login(credentials) {
      const { data } = await axios.post('/auth/login', credentials)
      this.token = data.token
      localStorage.setItem('token', data.token)
    },
    logout() {
      this.token = null
      this.user = null
      localStorage.removeItem('token')
    }
  }
})
